<template>
    <div class="comp__table-atc-ctas">
        <ProductATC
            :key="product"
            :product="product"
            :productForm="getProductForm(product)"
            :selectedVariant="getProductForm(product).selectedVariant"
            :selectedFirstOption="firstLevelSelectedOption"
        />
        <a :href="`/products/${product.handle}?color=${product.Color}`" tabindex="0"
            class="comp__table-view-product-cta">
            View Product Details
        </a>
    </div>
</template>

<script setup>
import { computed, toRefs } from 'vue';
import { useStore } from 'vuex';
import ProductATC from '../../pdp-first-fold/components/product-atc.vue';

const props = defineProps({
    product: Object,
    getProductForm: Function,
});

const { product } = toRefs(props);
const store = useStore();

const firstLevelSelectedOption = computed(() => {
    return store.state.pdp.firstLevelOptions?.[product.value.id] || {};
});

</script>
